// import React from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import "moment/locale/es";
import { getSession, getSessionTesting } from "../store/ducks/duckSession";
import { log } from "../utils/logger";

const PROMPTS_ANSWER_XML = "promptsAnswerXML";
const PROJECT = "Project";
const SERVER = "Server";
const SESSION = "usrSmgr";
const USER = "uid";
const PASSWORD = "pwd";

const LEGACY_PL_DOCUMENT_ID = "67C3610949981F8074A9F8B165C7937C";
const PL_APP_URL =
  "https://techint-parallel.cloud.strategy.com/MicroStrategyLibrary/app/D5A0288346862D730DF3B2AC97FE7586/F5DB41A549ED0140DA32CFB94AA7679A/";

const MICROSTRATEGY_SERVERS = [
  "https://techint-parallel.cloud.strategy.com/MicroStrategyLibrary/app",
  "https://mstrdev.teic.techint.net",
];

/**
 * Hook For Manipulate UrlSource
 */
const useURL = (requireFormatNumber = false) => {
  const { history, historyLoaded } = useSelector((state) => state.layout);
  const { data: sessions, loading } = useSelector((state) => state.session);

  const { testing: isTesting } = useSelector((state) => state.layout.layoutSelected);
  const dispatch = useDispatch();
  const regex = /(\{\w*\})/gm;

  const FORMAT_MONTH = requireFormatNumber ? "MM" : "MMM";

  const setParam = (_name, _value) => {};

  /**
   * Populate session and server in url Search Params.
   * @param {URLSearchParams} urlSearchParams parameters to get projectName and find session.
   * @param {boolean} requiredLogin Required Login.
   * @returns {URLSearchParams} UrlSearchParams with Session and server.
   */
  const populateSessionAndServer = (urlSearchParams, requiredLogin, sso) => {
    if (requiredLogin && !isTesting) {
      urlSearchParams.delete(SESSION);

      return urlSearchParams;
    }

    if (sso) {
      urlSearchParams.delete(SESSION);
      urlSearchParams.delete(USER);
      urlSearchParams.delete(PASSWORD);

      return urlSearchParams;
    }

    if (urlSearchParams.has(PROJECT)) {
      let projectName = urlSearchParams.get(PROJECT);

      let conditionSession = isTesting
        ? (s) => s.projectName === projectName && s.testing
        : (s) => s.projectName === projectName && !s.testing;
      let session = sessions.find(conditionSession);

      if (!session && !requiredLogin) {
        let action = isTesting ? getSessionTesting(projectName) : getSession(projectName);

        dispatch(action);

        return urlSearchParams;
      }

      let sessionsValid = session?.sessions.filter((s) => s.session !== null);

      if ((!sessionsValid || sessionsValid?.length === 0) && !requiredLogin) {
        log(`No se han conseguido sesiones activas en el Proyecto: ${projectName}`, "error");

        return urlSearchParams;
      }

      const { server, session: sessionCurrent } = getRandom(sessionsValid);

      urlSearchParams.set(SERVER, server);

      if (!isTesting) {
        urlSearchParams.set(SESSION, sessionCurrent);
      }
    } else if (!urlSearchParams.has(PROJECT) && sessions.length > 0) {
      let { sessions: sessionsOfFirst } = sessions[0];
      const { server, session: sessionCurrent } = getRandom(sessionsOfFirst);

      urlSearchParams.set(SERVER, server);
      urlSearchParams.set(SESSION, sessionCurrent);
    }

    // if(sso){
    //   urlSearchParams.delete(SESSION);
    //   urlSearchParams.delete(USER);
    //   urlSearchParams.delete(PASSWORD);
    // }

    return urlSearchParams;
  };

  /**
   * Populate XML
   * @param {URLSearchParams} urlSearchParams urlSearchParams.
   * @param {URL} urlObject urlObject.
   * @returns {URLSearchParams} UrlSearchParams with xml Populated
   */
  const populateXML = (urlSearchParams, urlObject) => {
    if (!urlSearchParams.has(PROMPTS_ANSWER_XML)) {
      return urlSearchParams;
    }

    let xmlString = urlSearchParams.get(PROMPTS_ANSWER_XML);
    let parser = new DOMParser();
    //normalizo
    let xmlDecoded = decodeURIComponent(xmlString);
    //paso a XML Dom
    let xmlDoc = parser.parseFromString(xmlDecoded, "text/xml");

    for (let i = 0; i < xmlDoc.getElementsByTagName("pa").length; i++) {
      let pa = xmlDoc.getElementsByTagName("pa")[i];

      if (regex.test(pa.textContent)) {
        moment.locale("es");
        let localLocale = moment();

        localLocale.locale(false);

        let monthDefault = localLocale.subtract(2, "months").format(FORMAT_MONTH);
        let yearDefault = localLocale.subtract(2, "months").format("YYYY");

        let month = history && history["MONTH"] ? history["MONTH"] : monthDefault;
        let year = history && history["YEAR"] ? history["YEAR"] : yearDefault;

        pa.textContent = pa.textContent.replace("{YEAR}", year);

        let formattedMonth = requireFormatNumber
          ? moment().month(month).format(FORMAT_MONTH)
          : month.toUpperCase().replace(".", "");

        //si es default tiene '.'
        pa.textContent = pa.textContent.replace("{MONTH}", formattedMonth);

        if (history) {
          for (const key in history) {
            if (history.hasOwnProperty(key) && (key !== "YEAR" || key !== "MONTH")) {
              const element =
                history[key] && history[key]?.trim() !== "TOTAL" && history[key] !== ""
                  ? history[key]
                  : "";

              switch (element) {
                case "TOTAL":
                  pa.textContent = pa.textContent.replace(`{${key}}`, "");
                  break;
                case "YEAR":
                  pa.textContent = pa.textContent.replace(`{${key}}`, year);
                  break;
                case "MONTH":
                  let formattedMonth = requireFormatNumber
                    ? moment().month(month).format(FORMAT_MONTH)
                    : month.toUpperCase().replace(".", "");

                  pa.textContent = pa.textContent.replace(`{${key}}`, formattedMonth);
                  break;
                default:
                  if (
                    urlSearchParams.has("Project") &&
                    urlSearchParams.get("Project") === "Economics"
                  ) {
                    let formattedText = element.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

                    pa.textContent = pa.textContent.replace(`{${key}}`, formattedText);
                  } else {
                    pa.textContent = pa.textContent.replace(`{${key}}`, element);
                  }
              }
            }
          }
        }

        pa.textContent = pa.textContent.replace(regex, "");
        pa.textContent = pa.textContent.trim();
      } else if (pa.textContent === "TOTAL") {
        pa.textContent = "";
      }
    }

    //paso a string
    let xmlPopulated = new XMLSerializer().serializeToString(xmlDoc.documentElement);

    urlSearchParams.set(PROMPTS_ANSWER_XML, xmlPopulated);

    urlObject.search = decodeURIComponent(urlSearchParams);

    let result = urlObject.origin + urlObject.pathname + "?" + decodeURIComponent(urlSearchParams);

    log(`${result}`);

    return result;
  };

  /**
   *
   * @param {Array} array array
   * @returns {Object} Random element
   */
  const getRandom = (array) => {
    return array[Math.floor(Math.random() * array.length)];
  };

  /**
   *
   * @param {string} url Url To Check
   *
   * @returns {boolean} boolean
   */
  const haveUserAndPassword = (url) => {
    if (!isValidUrl(url)) return url;

    let urlObject = new URL(url);
    let paramUrl = new URLSearchParams(urlObject.search);

    return paramUrl.has("uid") && paramUrl.has("pwd");
  };

  /**
   *  Get string populated
   * @param {string} url2 URL with variables
   * @param {boolean} [requiredLogin=false] Required Login for default is False.
   * @returns {string} url Populated
   */
  const cleanParams = (url2, requiredLogin = false, sso = false) => {
    if (!isValidUrl(url2)) return url2;

    if (!historyLoaded || loading) {
      return "";
    }

    let urlObject = new URL(url2);
    let paramUrl = new URLSearchParams(urlObject.search);

    if (paramUrl.get("documentID") === LEGACY_PL_DOCUMENT_ID) {
      return PL_APP_URL;
    }

    paramUrl.delete(USER);
    paramUrl.delete(PASSWORD);

    const isMicrostrategyServer = MICROSTRATEGY_SERVERS.some(
      (server) => new URL(server).hostname === urlObject.hostname,
    );

    if (isMicrostrategyServer) {
      paramUrl = populateSessionAndServer(paramUrl, requiredLogin, sso);
    }
    urlObject.search = paramUrl;

    let value = paramUrl.get(PROMPTS_ANSWER_XML);
    let isValidContentToParse =
      value?.includes("<rsl>") || value?.includes("</rsl>") || value?.includes("</pa>");

    if (paramUrl.has(PROMPTS_ANSWER_XML) && isValidContentToParse) {
      return populateXML(paramUrl, urlObject);
    } else {
      let urlPopulated = urlObject.origin + urlObject.pathname + "?" + decodeURIComponent(paramUrl);

      return populateUrlWithoutParams(urlPopulated);
    }
  };

  const populateUrlWithoutParams = (url) => {
    let urlProcesed = url;
    const regex = /(\{\w*\})/gm;

    if (regex.test(urlProcesed) && history) {
      for (const key in history) {
        if (history.hasOwnProperty(key)) {
          const element = history[key];

          if (key === "MONTH" && requireFormatNumber) {
            let formattedMonth = requireFormatNumber
              ? moment().month(element).format(FORMAT_MONTH)
              : element;

            urlProcesed = urlProcesed.replace(`{${key}}`, formattedMonth);
          } else {
            urlProcesed = urlProcesed.replace(`{${key}}`, element);
          }
        }
      }
      log(urlProcesed);

      return urlProcesed;
    }
    log(url);

    return url;
  };

  const getParams = (url) => {
    if (!isValidUrl(url)) return false;

    let urlObject = new URL(url);
    let paramUrl = new URLSearchParams(urlObject.search);

    let paramsImportants = ["documentID", PROJECT];

    let result = paramsImportants.map((p) => {
      let hasParam = paramUrl.has(p);

      if (hasParam) {
        let value = paramUrl.get(p);

        return { key: p, value };
      }

      return null;
    });

    result = result.filter((x) => x !== undefined && x !== null);

    return result.length > 0 ? result : false;
  };

  const getVariables = (url) => {
    if (!isValidUrl(url)) return false;
    const regex = /(\{\w*\})/gm;

    let variables = url.match(regex)?.length > 0 ? url.match(regex) : false;

    if (variables) {
      variables = variables.map((v) => {
        let procesed = v.replace(/\{/gm, "");

        procesed = procesed.replace(/\}/gm, "");

        return procesed;
      });
    }

    return variables ? variables : false;
  };

  /**
   *
   * @param {string} string UrlString
   * @returns isValid
   */
  const isValidUrl = (string) => {
    try {
      new URL(string);
    } catch (_) {
      return false;
    }

    return true;
  };

  return {
    setParam,
    getParams,
    cleanParams,
    isValidUrl,
    getVariables,
    haveUserAndPassword,
  };
};

export default useURL;
